(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
const {FABRICS,MODULAR_FABRICS,LENGTHS,CUSTOM_LENGTH,ORIENTATIONS,SHAPES,INSULATION,MODULAR_INSULATION,MODULAR,YES_NO,WRAP_AREAS,SACK_CLASSES,SACK_RATE,NORMAL_SIDE_ASSEMBLY,UL_SIDE_ASSEMBLY,MINI_SUSPENSION,BASE_SNAP_SET,ADD_ON_ATTACHMENT_SET}=window.SLDEstimatorData.products["trail_winder"];

  const FIELD_LABELS = Object.freeze({
    'Base Fabric/Color (hammock side)\n*\n(required)': 'Base Fabric',
    'Insulation Cover Fabric/Color (ground side)\n*\n(required)': 'Cover Fabric',
    'Insulation Weight\n*\n(required)': 'Insulation',
    'Hammock Length\n*\n(required)': 'Length',
    'Insulation Orientation\n*\n(required)': 'Orientation',
    "Modular Add On\n*\n(required)": 'Modular',
    'Modular Shell Fabric (ONLY IF ADDED ABOVE)': 'Modular Shell Fabric',
    'Modular Insulation Weight (ONLY IF ADDED ABOVE)': 'Modular Insulation',
    'Compression Sack\n*\n(required)': 'Compression Sack',
    'Separate Stuff Sack for Modular Add On\n*\n(required)': 'Separate Stuff Sack'
  });

  

  

  
  
  
  
  
  
  
  
  const DEFAULTS = Object.freeze({
    Insulation: 'Apex Climashield 2.5 (50°F)',
    Modular: 'No',
    'Compression Sack': 'No',
    'Separate Stuff Sack': 'No'
  });
  
  
  
  
  
  
  
  
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const exactText = (value) => String(value || '').trim();

  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const label=Object.keys(FIELD_LABELS).find(key=>key.replace(/\s+/g,' ').trim()===String(element.labels&&element.labels[0]&&element.labels[0].textContent||'').replace(/\s+/g,' ').trim());
      if (!own(FIELD_LABELS, label)) continue;
      selected[FIELD_LABELS[label]] = exactText(element.value);
    }
    return selected;
  }

  function preference(choice, field) {
    const value = choice[field];
    return value === undefined || value === '' ? DEFAULTS[field] : value;
  }

  function sackDimensions(nominalApex, shape) {
    const sackClass = SACK_CLASSES.find((entry) => nominalApex <= entry.max);
    if (!sackClass) return null;
    return {
      first: sackClass.first + shape.sackFirst,
      second: sackClass.second + shape.sackSecond
    };
  }

  function sackWeight(nominalApex, shape) {
    const dimensions = sackDimensions(nominalApex, shape);
    return dimensions ? dimensions.first * dimensions.second * SACK_RATE : null;
  }

  function formatWeight(ounces) {
    const displayedOunces = Number(ounces.toFixed(1));
    return displayedOunces.toFixed(1) + ' oz / ' + Math.round(displayedOunces * 28.349523125) + ' g';
  }

  function estimate(choice) {
    if (choice.Length === CUSTOM_LENGTH) return { manual: true };

    const baseFabric = FABRICS[choice['Base Fabric']];
    const coverFabric = FABRICS[choice['Cover Fabric']];
    const rawLength = LENGTHS[choice.Length];
    const shapeName = ORIENTATIONS[choice.Orientation];
    const shape = SHAPES[shapeName];
    if (!baseFabric || !coverFabric || !rawLength || !shape) return null;

    const insulation = INSULATION[preference(choice, 'Insulation')];
    const modularMode = MODULAR[preference(choice, 'Modular')];
    const compressionSack = YES_NO[preference(choice, 'Compression Sack')];
    const separateStuffSack = YES_NO[preference(choice, 'Separate Stuff Sack')];
    if (!insulation || modularMode === undefined || compressionSack === undefined || separateStuffSack === undefined) return null;

    let modularFabric = null;
    let modularInsulation = null;
    if (modularMode === 'add-on') {
      modularFabric = MODULAR_FABRICS[choice['Modular Shell Fabric']];
      modularInsulation = MODULAR_INSULATION[choice['Modular Insulation']];
      if (!modularFabric || !modularInsulation) return null;
    }

    const baseFabricWeight = rawLength * baseFabric.width / 1296 * baseFabric.density;
    const baseApexWeight = shape.baseArea / 1296 * insulation.density;
    const wrapShellWeight = WRAP_AREAS[shapeName][insulation.coefficient] * coverFabric.density;
    const qualifiesForUlSideAssembly = insulation.nominal === 2.5
      && modularMode === 'none'
      && baseFabric.ultralight
      && coverFabric.ultralight;
    const sideAssemblyWeight = qualifiesForUlSideAssembly ? UL_SIDE_ASSEMBLY : NORMAL_SIDE_ASSEMBLY;
    const modularReadyWeight = modularMode === 'none' ? 0 : BASE_SNAP_SET;
    const finishedBase = baseFabricWeight + baseApexWeight + wrapShellWeight
      + sideAssemblyWeight + MINI_SUSPENSION + modularReadyWeight;

    let finishedAddOn = 0;
    let addOnApexWeight = 0;
    let addOnShellWeight = 0;
    if (modularMode === 'add-on') {
      const addOnAreaSqYd = shape.addOnArea / 1296;
      addOnApexWeight = addOnAreaSqYd * modularInsulation.density;
      addOnShellWeight = 2 * addOnAreaSqYd * modularFabric.density;
      finishedAddOn = addOnApexWeight + addOnShellWeight + ADD_ON_ATTACHMENT_SET;
    }

    const finished = finishedBase + finishedAddOn;
    const combinedNominalApex = insulation.nominal + (modularInsulation ? modularInsulation.nominal : 0);
    const mainStuffSackWeight = sackWeight(combinedNominalApex, shape);
    const separateStuffSackWeight = modularMode === 'add-on' && separateStuffSack
      ? sackWeight(modularInsulation.nominal, shape)
      : 0;
    if (mainStuffSackWeight === null || separateStuffSackWeight === null) return null;

    return {
      base_fabric_weight: baseFabricWeight,
      base_apex_weight: baseApexWeight,
      wrap_shell_weight: wrapShellWeight,
      side_assembly_weight: sideAssemblyWeight,
      mini_suspension_weight: MINI_SUSPENSION,
      modular_ready_weight: modularReadyWeight,
      finished_base_weight: finishedBase,
      add_on_apex_weight: addOnApexWeight,
      add_on_shell_weight: addOnShellWeight,
      finished_add_on_weight: finishedAddOn,
      finished_quilt_weight: finished,
      main_stuff_sack_weight: mainStuffSackWeight,
      separate_stuff_sack_weight: separateStuffSackWeight,
      stuff_sack_weight: mainStuffSackWeight + separateStuffSackWeight,
      compression_sack_weight: null,
      compression_sack_class: 'unclassified',
      compression_sack_selected: compressionSack
    };
  }

  function start() {
    const root = document.querySelector('[data-sld-trail-winder-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;

    function calculate() {
      const choice = selections(scope);
      const result = estimate(choice);
      const results = root.querySelector('[data-sld-estimator-results]');
      const message = root.querySelector('[data-sld-estimator-message]');
      if (!result || result.manual) {
        if (results) results.hidden = true;
        if (message) message.textContent = result && result.manual
          ? 'Custom-fit Trail Winders require a manual weight estimate. Please contact me before ordering.'
          : choice.Modular === 'Yes' && (!choice['Modular Shell Fabric'] || !choice['Modular Insulation'])
            ? 'Select the modular shell fabric and modular insulation weight to include the modular layer in the estimate.'
          : 'Select the base fabric, insulation-area cover fabric, hammock length, and insulation orientation to see the estimated weight.';
        return;
      }
      const quilt = root.querySelector('[data-sld-weight-quilt]');
      const stuffSack = root.querySelector('[data-sld-weight-stuff-sack]');
      const compressionSack = root.querySelector('[data-sld-compression-sack]');
      if (quilt) quilt.textContent = formatWeight(result.finished_quilt_weight);
      if (stuffSack) stuffSack.textContent = formatWeight(result.stuff_sack_weight);
      if (compressionSack) compressionSack.textContent = result.compression_sack_selected
        ? '2–4 oz / 57–113 g'
        : 'Not selected';
      if (results) results.hidden = false;
      if (message) message.textContent = '';
    }

    let timer;
    const queue = () => {
      clearTimeout(timer);
      timer = setTimeout(calculate, 75);
    };
    document.addEventListener('change', queue, true);
    document.addEventListener('input', queue, true);
    document.addEventListener('click', queue, true);
    new MutationObserver(queue).observe(scope, {
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'selected', 'class', 'aria-checked'],
      childList: true
    });
    calculate();
  }

  return {
    CUSTOM_LENGTH,
    FABRICS,
    FIELD_LABELS,
    INSULATION,
    LENGTHS,
    MODULAR,
    MODULAR_FABRICS,
    MODULAR_INSULATION,
    ORIENTATIONS,
    SHAPES,
    WRAP_AREAS,
    estimate,
    formatWeight,
    sackDimensions,
    sackWeight,
    selections,
    start
  };
});
